import { createGlobalState } from '@vueuse/core'
import { computed } from 'vue'
import { is_small_screen } from '../../../utils'

export const useFixedHeaderHeight = createGlobalState(() => {
  const fixedHeaderHeight = computed(() => is_small_screen() ? 55 : 65)

  return {
    fixedHeaderHeight,
  }
})
